import { useDispatch, useSelector } from "react-redux";
import { RootState } from "slices";
import {
  clearAllNotifications,
  markAllAsRead,
  markAsRead,
  removeNotification,
} from "slices/notifications/reducer";
import {
  addErrorNotification,
  addInfoNotification,
  addNotificationWithIcon,
  addSuccessNotification,
  addWarningNotification,
  simulateServerNotification,
} from "slices/notifications/thunk";
import { AddNotificationPayload } from "slices/notifications/types";

export const useNotifications = () => {
  const dispatch = useDispatch();
  const notificationsState = useSelector((state: RootState) => state.Notifications);

  return {
    // Estado das notificações
    notifications: notificationsState.notifications,
    unreadCount: notificationsState.unreadCount,
    loading: notificationsState.loading,
    error: notificationsState.error,

    // Ações para adicionar notificações
    addNotification: (payload: AddNotificationPayload) =>
      dispatch(addNotificationWithIcon(payload) as any),

    addSuccess: (message: string) => dispatch(addSuccessNotification(message) as any),

    addError: (message: string) => dispatch(addErrorNotification(message) as any),

    addWarning: (message: string) => dispatch(addWarningNotification(message) as any),

    addInfo: (message: string) => dispatch(addInfoNotification(message) as any),

    // Ações de controle
    markAsRead: (id: string) => dispatch(markAsRead(id)),
    markAllAsRead: () => dispatch(markAllAsRead()),
    removeNotification: (id: string) => dispatch(removeNotification(id)),
    clearAll: () => dispatch(clearAllNotifications()),

    // Função de demonstração
    simulateNotification: () => dispatch(simulateServerNotification() as any),
  };
};
